import { UserGroup } from './user-entitlement.model';

export enum Entitlement {
    ATTACHMENT_EDIT = 'Attachment Edit',
    CROSSTALK_RESTRICTED_ATTACHMENT = 'Crosstalk Restricted Attachment',
    DASHBOARD_CREATE = 'Dashboard Create',
    DASHBOARD_DELETE = 'Dashboard Delete',
    DASHBOARD_EDIT = 'Dashboard Edit',
    DASHBOARD_VIEW = 'Dashboard View',
    EXPORT = 'Export',
    EXTERNAL_SHARE = 'External Share',
    GLOBAL_EDIT_PARTIAL = 'Global Edit Partial',
    VIEW_AND_EDIT_ALL = 'DDV View and Edit All',
    VIEW_GROUP_MANAGE = 'Manage View Family',
    WIDGET_CREATE = 'Widget Create',
    WIDGET_DELETE = 'Widget Delete',
    WIDGET_EDIT = 'Widget Edit',
    WIDGET_VIEW = 'Widget View',
}

export const USER_GROUP_TOOLTIP_MAP: ReadonlyMap<string, string> = new Map([
    [UserGroup.HS_USERS.toUpperCase(), 'Internal users with client access'],
    [UserGroup.CLIENT_USERS.toUpperCase(), 'External users with basic access'],
    [UserGroup.CLIENT_LIMITED_USERS.toUpperCase(), 'External users with restricted access'],
]);
